@if (currentSuite(); as currentSuite) {
  <!-- EXT-6537: the tabs on the left; on the right, whatever app.component
       projects in (later EXT-6500's Event ID). Right-aligned, so it follows
       the drawer's edge. EXT-6573 moved the account lookup to the account
       bar. -->
  <div class="module-row">
    <nav mat-tab-nav-bar [tabPanel]="tabPanel" mat-stretch-tabs="false">
      <a mat-tab-link routerLink="/home" aria-label="Home"
        ><mat-icon>home</mat-icon></a
      >
      @for (module of mainModules(); track module.data.enumeration) {
        <div [matTooltip]="module.tooltip">
          <a
            mat-tab-link
            [routerLink]="module.data.routes[0]"
            [active]="module.data.enumeration === currentModule()?.enumeration"
            [disabled]="module.disabled"
            >{{ module.data.suiteTabLabel ?? module.data.name }}</a
          >
        </div>
      }
      @if (moreModules().length > 0) {
        <a
          mat-tab-link
          [matMenuTriggerFor]="moreMenu"
          [active]="isMoreModuleActive()"
          >More...</a
        >
      }
    </nav>
    <div class="module-row-tools">
      <ng-content></ng-content>
    </div>
  </div>
  <mat-tab-nav-panel #tabPanel></mat-tab-nav-panel>

  <mat-menu #moreMenu="matMenu">
    @for (module of moreModules(); track module.data.enumeration) {
      <a
        mat-menu-item
        [routerLink]="module.data.routes[0]"
        [queryParams]="moreMenuQueryParams(module.data.enumeration)"
        [matTooltip]="module.tooltip"
        [disabled]="module.disabled"
        >{{ module.data.suiteTabLabel ?? module.data.name }}</a
      >
    }
  </mat-menu>
}
